import { type ProgramTaskSchedule } from '@terros/common'
import { stringifyPlace, WEEKDAYS } from '../competition'

export function getLabelForDay(schedule: ProgramTaskSchedule, occurance: number): string {
  const fallback = stringifyPlace(occurance + 1)
  if (schedule.type === 'none') return fallback
  if (schedule.type === 'day') {
    const day = schedule.days.at(occurance)
    if (!day) return fallback
    return `Day ${day}`
  }

  if (schedule.type === 'sequentialWeekday') {
    return fallback
  }

  const weekdays: { weekday: number; week: number }[] = []
  schedule.days.forEach((d) => {
    d.weeks.forEach((w) => {
      weekdays.push({ weekday: d.weekday, week: w })
    })
  })

  weekdays.sort((a, b) => {
    if (a.week === b.week) return a.weekday - b.weekday
    return a.week - b.week
  })

  const weekday = weekdays.at(occurance)

  if (!weekday) return fallback

  return `${WEEKDAYS[weekday.weekday - 1]} week ${weekday.week}`
}
